'use client';

import {
    Box,
    BoxContent,
    Columns,
    ColumnsItem,
    Icon,
    IconName,
    Image,
    List,
    ListItem,
    Text,
    TextLevels,
    TrilogyColor,
} from '@bytel/trilogy-react-ts';

import { FaiProduct } from '@app-types/fai';

export function BBoxDetail({ selectedFaiProduct }: Readonly<{ selectedFaiProduct?: FaiProduct | null }>) {
    if (!selectedFaiProduct) {
        return null;
    }
    const speedDown = selectedFaiProduct.pre_elig_speed_down
        ? `${selectedFaiProduct.pre_elig_speed_down} Gb/s`
        : selectedFaiProduct.product.speed_down;
    const speedUp = selectedFaiProduct.pre_elig_speed_up
        ? `${selectedFaiProduct.pre_elig_speed_up} Gb/s`
        : selectedFaiProduct.product.speed_up;
    const speedWording = selectedFaiProduct.pre_elig_speed_wording;
    const sortedNuggets = [...selectedFaiProduct.nuggets]?.sort((a, b) => {
        const positionA = a.position ?? Number.MAX_SAFE_INTEGER;
        const positionB = b.position ?? Number.MAX_SAFE_INTEGER;
        return +positionA - +positionB;
    });

    // made in urgency because new icons are not available in trilogy 3.9.x. During migration to v4, you can revert to previous (ask Jo)!!!
    const getTemporaryIcon = (pictoNuggets: string): string | null => {
        if (pictoNuggets.includes('wifi-6')) {
            return null;
        }
        if (selectedFaiProduct.commercial_series === 'serie_client_bandyou' && pictoNuggets.includes('gauge')) {
            return 'gauge-wifi6';
        }
        if (pictoNuggets.includes('gauge')) {
            return 'gauge-wifi7';
        }
        if (pictoNuggets.includes('wifi')) {
            return 'wifi7';
        }
        return null;
    };
    return (
        <div>
            <Box shadowless>
                <BoxContent background={TrilogyColor.GREY_LIGHTER} className='padding-medium'>
                    <List hasIcon className='is-flex is-vertical gap-medium'>
                        {sortedNuggets?.map((nugget) => {
                            return (
                                <ListItem
                                    key={nugget.texte}
                                    customIcon={
                                        !getTemporaryIcon(nugget.logo_nuggets)
                                            ? (nugget.logo_nuggets as IconName)
                                            : undefined
                                    }
                                    className='has-text-left gap-medium is-aligned-center'
                                >
                                    <Columns multiline mobile marginless verticalCentered className='gap-medium'>
                                        {getTemporaryIcon(nugget.logo_nuggets) && (
                                            <ColumnsItem className='is-paddingless' narrow>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: '30px',
                                                        height: '30px',
                                                    }}
                                                >
                                                    <Image
                                                        src={`https://bouyguestelecom.fr/assets/media/full/image/CMS/ecommerce/byou/${getTemporaryIcon(nugget.logo_nuggets)}.webp`}
                                                        alt=''
                                                        style={{
                                                            width: '20px',
                                                            height: '20px',
                                                        }}
                                                    />
                                                </div>
                                            </ColumnsItem>
                                        )}
                                        <ColumnsItem className='is-flex is-aligned-center'>
                                            <Columns multiline>
                                                <ColumnsItem className='is-paddingless w-fit '>
                                                    <Text level={TextLevels.TWO} marginless>
                                                        {nugget.texte}
                                                        {speedWording && nugget.show_speed && ' ' + speedWording}
                                                    </Text>
                                                </ColumnsItem>
                                                {selectedFaiProduct && nugget.show_speed && (
                                                    <ColumnsItem narrow className='is-paddingless'>
                                                        <Columns
                                                            marginless
                                                            mobile
                                                            verticalCentered
                                                            className='flex-nowrap is-justified-start gap-x-medium'
                                                            aria-label={`${speedDown} en débit descendant et ${speedUp} en débit montant`}
                                                        >
                                                            <ColumnsItem
                                                                narrow
                                                                className='is-paddingless is-inline-flex'
                                                            >
                                                                <Text
                                                                    level={TextLevels.TWO}
                                                                    marginless
                                                                    className='is-inline-flex'
                                                                >
                                                                    <Icon
                                                                        marginless
                                                                        name={IconName.ARROW_BOTTOM}
                                                                        content={speedDown}
                                                                        className='pack'
                                                                        textClassName='text-nowrap'
                                                                    />
                                                                </Text>
                                                            </ColumnsItem>
                                                            <ColumnsItem className='is-paddingless is-inline-flex'>
                                                                <Text
                                                                    level={TextLevels.TWO}
                                                                    marginless
                                                                    className='is-inline-flex'
                                                                >
                                                                    <Icon
                                                                        marginless
                                                                        name={IconName.ARROW_HIGH}
                                                                        content={speedUp}
                                                                        className='pack'
                                                                        textClassName='text-nowrap'
                                                                    />
                                                                </Text>
                                                            </ColumnsItem>
                                                        </Columns>
                                                    </ColumnsItem>
                                                )}
                                            </Columns>
                                        </ColumnsItem>
                                    </Columns>
                                </ListItem>
                            );
                        })}
                    </List>
                </BoxContent>
            </Box>
        </div>
    );
}
